import React from 'react';
import FaqContent from './FaqContent';

const Answer = ({ content }) => {
  return (
    <div className='space-y-6 pt-8'>
      {content.map((content, index) => (
        <FaqContent content={content} key={index} />
      ))}
    </div>
  );
};

export default Answer;
